export default "__VITE_ASSET__f9eaf520__"